import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik } from "formik";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "./signin.css";
import {
  login,
  register,
  reSendVerificationCode,
  showSuccessModel,
  closeSigninModal,
} from "../../store/reducers";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { verifyemail } from "../../store/reducers";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";

function SignUp() {
  const [show, setShow] = useState(false);
  const [email, setemail] = useState();
  const [password, setpassword] = useState();
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get modal state from Redux
  const { isOpen, onClose } = useSelector(state => ({
    isOpen: state.counter?.signinModalState?.isOpen,
    onClose: state.counter?.signinModalState?.onClose
  }));

  console.log('SignUp - isOpen:', isOpen);
  console.log('SignUp - onClose callback exists:', !!onClose);

  // Clear stored password when modal opens to prevent showing decrypted password
  useEffect(() => {
    if (isOpen || show) {
      localStorage.removeItem("PASSWORD_TO_CONFIRM");
      setpassword(undefined);
      setShowPassword(false);
    }
  }, [isOpen, show]);

  const handleClose = () => {
    console.log('SignUp close button clicked');
    
    // Clear any stored password from localStorage when closing
    localStorage.removeItem("PASSWORD_TO_CONFIRM");
    // Clear password state
    setpassword(undefined);
    setShowPassword(false);
    setVerifyEmail(false);
    
    // Call the external onClose callback if it exists (from CompanyClaim)
    if (onClose && typeof onClose === 'function') {
      console.log('Calling external onClose callback from SignUp');
      onClose();
    }
    
    setShow(false);
    dispatch(closeSigninModal());
  };

  const handleShow = () => {
    // Clear any stored password from localStorage to prevent showing decrypted password
    localStorage.removeItem("PASSWORD_TO_CONFIRM");
    setShow(true);
  };

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const lengthRegex = /^(?=.{8,})/;
  const lowerCaseRegex = /^(?=.*[a-z])/;
  const upperCaseRegex = /^(?=.*[A-Z])/;
  const specialCharacterRegex = /^(?=.*[!@#\$%\^&\*])/;
  const numberRegex = /^(?=.{6,20}$)\D*\d/;

  const initialValue = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  };

  const signUpSchema = Yup.object().shape({
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    email: Yup.string()
      .email("Invalid email address format")
      .required("Required"),
    password: Yup.string()
      .required("Please Enter your password")
      .matches(lengthRegex, "Must Contain 8 Characters")
      .matches(lowerCaseRegex, "Must Contain One Lowercase")
      .matches(upperCaseRegex, "Must Contain One Uppercase")
      .matches(specialCharacterRegex, "Must Contain One Special Case Character")
      .matches(numberRegex, "Must Contain One Number"),
  });

  const handleSubmit = (values, { resetForm, setFieldValue }) => {
    let param = { ...values }; // Create a copy to avoid mutating the form values
    const userPassword = values.password; // Store the original password before it gets hashed
    setemail(values.email);
    // Don't store password in state - it's already stored in localStorage by register action
    param["type"] = "landowner";

    // Clear password field immediately to prevent showing hash
    setFieldValue('password', '');
    setShowPassword(false);
    
    // Hide the form immediately by showing verification step
    // This prevents the hash from being displayed
    setVerifyEmail(true);

    setLoading(true);

    dispatch(register(param))
      .then((response) => {
        setLoading(false);
        if (response.meta.requestStatus === "fulfilled") {
          // Ensure form is completely reset
          resetForm({ values: { ...initialValue } });
          toast.success(response?.payload);
        } else {
          // If registration fails, go back to signup form and restore password
          setVerifyEmail(false);
          setFieldValue('password', userPassword);
          toast.error(response?.payload || "Registration failed");
        }
      })
      .catch((error) => {
        setLoading(false);
        // If registration fails, go back to signup form and restore password
        setVerifyEmail(false);
        setFieldValue('password', userPassword);
        const errorMessage = error?.payload || "Registration failed";
        toast.error(errorMessage);
      });
  };

  const [verifyEmail, setVerifyEmail] = useState(false);

  const verifyEmailSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address format")
      .required("Required"),
    code: Yup.string().required("Required"),
  });

  const initialValue1 = {
    email: localStorage.getItem("USERNAME_TO_CONFIRM"),
    code: "",
  };

  const handleSubmit1 = (values) => {
    const payload = {
      email: values.email,
      code: values.code,
    };
    setSending(true);
    dispatch(verifyemail(payload))
      .then(() => {
        const loginPayload = {
          email: localStorage.getItem("USERNAME_TO_CONFIRM"),
          password: localStorage.getItem("PASSWORD_TO_CONFIRM"),
        };

        dispatch(login(loginPayload)).then((data) => {
          localStorage.removeItem("USERNAME_TO_CONFIRM");
          localStorage.removeItem("PASSWORD_TO_CONFIRM");
          
          if (data?.payload?.access_token) {
            setSending(false);
            toast.success("Login successfully!");
            dispatch(showSuccessModel());
            setShow(false);
            dispatch(closeSigninModal());
            
            // First priority: Check if there's a pending claim link (from closed modal)
            const pendingClaimLink = localStorage.getItem('pendingClaimLink');
            if (pendingClaimLink) {
              console.log('Redirecting to pending claim link:', pendingClaimLink);
              localStorage.removeItem('pendingClaimLink');
              navigate(pendingClaimLink);
              return;
            }
            
            // Second priority: Check if there's a pending company claim (from session)
            const pendingClaim = sessionStorage.getItem('pendingCompanyClaim');
            if (pendingClaim) {
              const claimData = JSON.parse(pendingClaim);
              navigate(`company/claim/${claimData.company_id}`);
              return;
            }
            
            // Default: Navigate to dashboard
            navigate("/dashboard");
          } else {
            setSending(false);
            toast.error(data?.payload?.message || "Login failed");
          }
        });
      })
      .catch((error) => {
        setSending(false);
        toast.error(error?.payload || "Email verification failed");
      });
  };

  const resend = () => {
    setSending(true);
    dispatch(
      reSendVerificationCode(localStorage.getItem("USERNAME_TO_CONFIRM"))
    )
      .then((data) => {
        setSending(false);
        toast.success(data?.payload || "Code sent successfully");
      })
      .catch((error) => {
        setSending(false);
        toast.error(error?.payload || "Failed to resend code");
      });
  };

  return (
    <div className='nav-button-wi'>
      <button onClick={handleShow} className="btn-primary1">
        SIGN UP
      </button>

      <Dialog
        fullWidth={true}
        maxWidth="lg"
        id="popupDialog"
        open={show || isOpen}
        onClose={handleClose}
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogContent className="popup">
          <div className="flex-row exit-button">
            <IconButton
              className={"float-end p-0"}
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex-row">
            <div className="popup-img"></div>

            {!verifyEmail ? (
              <div className="popup-content">
                <h2 className="mb-5">Create Account</h2>
                <Formik
                  key={`signup-form-${show}-${isOpen}`}
                  initialValues={initialValue}
                  validationSchema={signUpSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize={false}
                >
                  {({ errors, touched, isValidating, values, setFieldValue }) => (
                    <Form>
                      <div className="row">
                        <b className="register_form_label">Name</b>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <Field
                              name="first_name"
                              placeholder="First name"
                              className={`form-control ${
                                touched.first_name && errors.first_name
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="first_name"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <div className="form-group">
                            <Field
                              name="last_name"
                              placeholder="Last name"
                              className={`form-control ${
                                touched.last_name && errors.last_name
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="last_name"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <b className="register_form_label">Login Email</b>
                        <div className="col-md-12 mb-3">
                          <div className="form-group">
                            <Field
                              name="email"
                              placeholder="Email address"
                              className={`form-control ${
                                touched.email && errors.email
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="email"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <b className="register_form_label">Password</b>
                        <div className="col-md-12 mb-3">
                          <div className="form-group">
                            <Field
                              type={showPassword ? "text" : "password"}
                              name="password"
                              placeholder="Password"
                              autoComplete="off"
                              className={`form-control ${
                                touched.password && errors.password
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <i
                              className={`fa ${
                                !showPassword ? "fa-eye" : "fa-eye-slash"
                              } fa-lg password_eye`}
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: 'pointer' }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row pass-requirements">
                        <div className="col-md-6">
                          <ul>
                            <>
                              <li
                                style={{ fontSize: "12px" }}
                                className={`${
                                  !lengthRegex.test(values.password)
                                    ? touched.password && errors.password
                                      ? "password_error"
                                      : ""
                                    : "password_success"
                                }`}
                              >
                                At least 8 Characters
                              </li>
                              <li
                                style={{ fontSize: "12px" }}
                                className={`${
                                  !upperCaseRegex.test(values.password) ||
                                  !lowerCaseRegex.test(values.password)
                                    ? touched.password && errors.password
                                      ? "password_error"
                                      : ""
                                    : "password_success"
                                }`}
                              >
                                Upper & lower case
                              </li>
                            </>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul>
                            <>
                              <li
                                style={{ fontSize: "12px" }}
                                className={`${
                                  !specialCharacterRegex.test(values.password)
                                    ? touched.password && errors.password
                                      ? "password_error"
                                      : ""
                                    : "password_success"
                                }`}
                              >
                                Special character
                              </li>
                              <li
                                style={{ fontSize: "12px" }}
                                className={`${
                                  !numberRegex.test(values.password)
                                    ? touched.password && errors.password
                                      ? "password_error"
                                      : ""
                                    : "password_success"
                                }`}
                              >
                                At least one number
                              </li>
                            </>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          {loading ? (
                            <LoadingButton
                              endIcon={<SendIcon />}
                              className="mb-3 w-100"
                              loading
                              loadingPosition="end"
                              variant="contained"
                            >
                              LOADING...
                            </LoadingButton>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary mb-3 w-100"
                            >
                              COMPLETE SIGN UP
                            </button>
                          )}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            ) : (
              <div className="popup-content">
                <h4>
                  Verify Email
                </h4>
                <small>( Check your mailbox for code )</small>
                <Formik
                  initialValues={initialValue1}
                  validationSchema={verifyEmailSchema}
                  onSubmit={handleSubmit1}
                >
                  {({ errors, touched, isValidating, values }) => (
                    <Form className={"mt-5"}>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <div className="form-group">
                            <Field
                              name="email"
                              value={email}
                              className="form-control"
                              disabled={true}
                              type="text"
                              placeholder="Email address"
                            />
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
                          <div className="form-group">
                            <Field
                              name="code"
                              placeholder="Code"
                              className={`form-control ${
                                touched.code && errors.code ? "is-invalid" : ""
                              }`}
                            />
                            <ErrorMessage
                              component="div"
                              name="code"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          {sending ? (
                            <LoadingButton
                              endIcon={<SendIcon />}
                              className="mb-3 w-100"
                              loading
                              loadingPosition="end"
                              variant="contained"
                            >
                              LOADING...
                            </LoadingButton>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary mb-3 w-100"
                              style={{ margin: "0" }}
                            >
                              SUBMIT
                            </button>
                          )}
                          <div style={{ marginTop: '8px' }}>
                            <a
                              onClick={resend}
                              style={{ cursor: "pointer" }}
                              className="text-decoration-underline"
                            >
                              {!sending ? "Resend Code" : "Sending ..."}
                            </a>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default SignUp;